// const isDisplayLogs = process.env.NODE_ENV !== "production" ? true : false;
const isDisplayLogs = false
export function logger(key, value) {
  if (isDisplayLogs) {
    console.log(key);
    console.log(value);
  }
}
